<template>
  <div>
    <div class="content">
      <div class="name">· 餐厅特色 ·</div>
      <div class="sr-text">
        <div class="sr-con" v-html="DATA.info.shopDescription"></div>
      </div>
    </div>
    <div class="content">
      <div class="name">· 推荐菜品 ·</div>
      <div class="sr-list">
        <ul>
          <li v-for="item in DATA.info.recommendDishes">
            <div class="box">
              <p class="img" v-lazy:background-image="imgUrl + item.path"></p>
              <p class="title" v-if="item.description">{{item.description}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      data: Object
    },
    data () {
      return {
        imgUrl: this.$store.state.imgUrl,
        DATA: this.data
      }
    }
  }
</script>

<style lang="less" scoped>
  .content {
    margin-bottom: 20px;
    background-color: white;
    border: 1px solid #eee;
    .name {
      padding: 20px 0;
      margin: 0 30px;
      text-align: center;
      font-weight: bold;
      font-size: 16px;
      color: #333;
      border-bottom: 1px solid #cdad66;
    }
    .sr-text {
      padding: 30px;
      background-color: white;
      .sr-con {
        line-height: 2;
        overflow: hidden;
      }
      img {
        max-width: 100%;
      }
    }
    .sr-list{
      padding: 10px 20px;
      ul {
        overflow: hidden;
        list-style: none;
      }
      li {
        float: left;
        width: 20%;
        .box {
          margin: 10px;
          position: relative;
        }
        .img {
          padding-top: 100%;
          background-position: center;
          background-size: cover;
          border: 1px solid #eee;
        }
        .title {
          position: absolute;
          top: 50%;
          right: 0;
          left: 0;
          padding: 10px 0;
          margin-top: -20px;
          text-align: center;
          color: white;
          background-color: rgba(187,161,73,.54);
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/pages/restaurant-detail/sr-content.vue